class MAskQuestion extends HTMLElement {
    constructor() {
        super(), this.selectors = {
            openButton: "[data-open-ask-question]",
            content: ".m-form-ask-question",
            container: ".m-product-addon"
        }
    }
    connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this), this.container = document.querySelector(this.selectors.container), this.domNodes.content && this.domNodes.content.innerHTML && (this.content = this.domNodes.content.innerHTML, this.init())
    }
    init() {
        this.modal = new RefurbishedTheme.Modal, addEventDelegate({
            selector: this.selectors.openButton,
            handler: e => {
                if (e.preventDefault(), this.content) {
                    var selectedvariant = document.querySelector("#product-form-installment input[name='id']").value;
                    var selectedSku = '';
                    JSON.parse(document.getElementById('productVariants').textContent).forEach(function(object) {
                      if (object.id == selectedvariant){
                        selectedSku = object.sku;
                      }
                    });
                    this.cont = "<iframe style=\"width:100%;\" height=\"660\" src=\"https://ims.refurbished.it/prod.php?sku=" + selectedSku + "\"></iframe>";
                    const e = document.createElement("DIV");
                    e.innerHTML = this.cont, this.modal.appendChild(e), this.modal.setWidth("500px"), this.container.classList.remove("m:hidden"), this.modal.open()
                }
            }
        })
    }
}
customElements.define("m-ask-question", MAskQuestion);